import { FC } from 'react';
import { Button } from '@chakra-ui/react';

type Props = {
  label: string;
  width?: string;
  onClick: () => void;
};

export const RegistrationButton: FC<Props> = ({
  label,
  width = 'auto',
  onClick,
}) => (
  <Button
    colorScheme="blue"
    size="sm"
    fontSize="16px"
    width={width}
    onClick={onClick}
  >
    {label}
  </Button>
);
